import { render, staticRenderFns } from "./TipoConveniosCadastro.vue?vue&type=template&id=70734e91&scoped=true&"
import script from "./TipoConveniosCadastro.vue?vue&type=script&lang=js&"
export * from "./TipoConveniosCadastro.vue?vue&type=script&lang=js&"
import style0 from "./TipoConveniosCadastro.vue?vue&type=style&index=0&id=70734e91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70734e91",
  null
  
)

export default component.exports